export default {
    getListProject () {
        return window.$http.get('/projects/')
    },
    createProject (projectName) {
        return window.$http.post('/projects/', { 'name': projectName })
    },
    handleCreateProjectError (error) {
        if (error.response) {
            if (error.response.status === 429) {
                window.vueapp.$appService.toastError(window.vueapp.$t('modalCreateProject.projectCountExceedLimit'))
            } else if (error.response.data) {
                window.vueapp.$appService.toastError(error.response.data)
            } else {
                window.vueapp.$appService.toastError(window.vueapp.$t('modalCreateProject.createProjectFailed'))
            }
        } else {
            window.vueapp.$appService.toastError(window.vueapp.$t('modalCreateProject.createProjectFailed'))
        }
    },
    getProjectReports (projectId, pageNo, pageSize, fromDate, toDate, serviceName, status, keyword) {
        return window.$http.get(
            `/projects/${projectId}/request-logs/`,
            {
                params: {
                    'page_size': pageSize,
                    'page': pageNo,
                    'from_date': fromDate,
                    'to_date': toDate,
                    'api_id': serviceName,
                    'status': status,
                    'keyword': keyword
                }
            }
        )
    },
    getProjectById (projectId) {
        return window.$http.get(`/projects/${projectId}/`)
    },
    deleteProject (id) {
        return window.$http.delete('/projects/' + id + '/')
    },
    getVersionPlatform () {
        return window.$http.get('/version/')
    },
}
